import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('QUOTATIONS', {
  ADD_QUOTATION_REQUEST: null,
  ADD_QUOTATION_SUCCESS: null,
  ADD_QUOTATION_FAILURE: null,
  UPDATE_QUOTATION_REQUEST: null,
  UPDATE_QUOTATION_SUCCESS: null,
  UPDATE_QUOTATION_FAILURE: null,
  REMOVE_QUOTATION_REQUEST: null,
  REMOVE_QUOTATION_SUCCESS: null,
  REMOVE_QUOTATION_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/QuotationsConstants.js